export enum PortalUrlTypeEnum {
  EstimateDetails = 1,
  EstimateChangeOrderDetails,
  Invoice,
  ProjectReport
}
